import Input from 'react-toolbox/lib/input'
import React from 'react'

import styles from './Input.scss'

const FulcrumInput = (props) => {
  return (
    <Input
      {...props}
      theme={styles}
    />
  )
}

export default FulcrumInput
